/**
 * Landing screen - Create or Join a market
 */

import { useEffect, useState } from "preact/hooks";
import { route } from "preact-router";
import { useStore } from "../store";
import { api } from "../api/client";
import type { Market, User } from "../api/types";

export function Landing() {
  const { deviceId, reset } = useStore();
  const [recentMarkets, setRecentMarkets] = useState<
    { market: Market; user: User }[]
  >([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    reset(); // Clear any previous session

    // Load recent markets for this device
    api
      .getDeviceMarkets(deviceId)
      .then((data) => {
        setRecentMarkets(data.markets);
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [deviceId, reset]);

  const handleRejoin = (market: Market, user: User) => {
    useStore.setState({ market, user });
    if (market.status === "draft") {
      route(`/lobby/${market.id}`);
    } else {
      route(`/market/${market.id}`);
    }
  };

  return (
    <div class="landing">
      <div class="landing-header">
        <img src="/icon-512.png" alt="CAZINO" class="logo-img" />
        <h1>CAZINO</h1>
        <p class="tagline">Private betting markets. Cheating encouraged.</p>
      </div>

      <div class="landing-actions">
        <button class="btn btn-primary" onClick={() => route("/create")}>
          Create Market
        </button>
        <button class="btn btn-secondary" onClick={() => route("/join")}>
          Join Market
        </button>
      </div>

      {!loading && recentMarkets.length > 0 && (
        <div class="recent-markets">
          <h3>Recent Markets</h3>
          <div class="recent-markets-list">
            {recentMarkets.map(({ market, user }) => (
              <button
                key={market.id}
                class="recent-market-item"
                onClick={() => handleRejoin(market, user)}
              >
                <div class="recent-market-name">{market.name}</div>
                <div class="recent-market-info">
                  <span class="recent-market-code">{market.inviteCode}</span>
                  <span class="recent-market-user">@{user.displayName}</span>
                  <span class="recent-market-status">{market.status}</span>
                </div>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
